import { useEffect, useState } from 'react';

import { useAsyncNew } from 'hooks/useAsyncNew';
import NetworkAppsService from 'services/network-apps/NetworkApps';
import usePlanFilters from 'hooks/usePlanFilters';
import { useOneChipInfoContext } from 'contexts/OneChipInfoContext';

const useSelectPlan = ({ preselect, readOnly }) => {
  const { info } = useOneChipInfoContext();
  const infoData = info.data;

  const [isNewData, setIsNewData] = useState(true);

  const [readOnlyFilters, setReadonlyFilters] = useState({});

  const planFilters = usePlanFilters({
    initialFilters: {
      limit: 10,
      offset: 0,
      sort: 'name:asc',
    },
    onSetFilter: (filterName, values, setFilters) => {
      const newFilters = { offset: 0 };
      setFilters((prev) => ({ ...prev, [filterName]: values, ...newFilters }));
      setIsNewData(true);
    },
  });

  const service = useAsyncNew(NetworkAppsService.getPlansList, { immediate: false });

  useEffect(() => {
    if (info.isSuccess && planFilters.selected) {
      service.execute({
        ...planFilters.selected,
        clientId: infoData?.esim?.clientId,
      });
    }
  }, [planFilters.selected]);

  useEffect(() => {
    if (info.isSuccess) {
      if (readOnly) {
        setReadonlyFilters(readOnly(infoData));
      }
      if (preselect) {
        const preselected = preselect(infoData);
        planFilters.setFilters((prev) => ({
          ...prev,
          ...preselected,
        }));
      }
    }
  }, [info.isSuccess]);

  return {
    isNewData,
    readOnlyFilters,
    setIsNewData,
    ...planFilters,
    ...service,
  };
};

export default useSelectPlan;
